module.exports = __webpack_public_path__ + "public/languageIcon.svg?5919ece0";